module.exports = __webpack_public_path__ + "img/4-4.5c956fe5.png";